import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject, OnDestroy } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppStateService } from '../../app-state.service';
import { FormConfigService } from '../forms-config.service';
import { AppEventService } from '../../app-event-service';

@Component({
  selector: 'app-consent-form',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    DynamicFormComponent,  // Import the dynamic form component
  ],
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.scss']
})
export class ConsentFormComponent implements OnInit, OnDestroy {
  appStateService = inject(AppStateService);
  formConfigService = inject(FormConfigService);
  snackBar = inject(MatSnackBar);
  eventService = inject(AppEventService)
  @Input() clientId: string = '';
  @Input() patientId: string = '';
  @Input() templateId: any;

  constructor(private route: ActivatedRoute) {
    this.clientId = this.appStateService.getState().clientId || '';
    this.patientId = this.appStateService.getState().patientId || sessionStorage.getItem('patientId') || '';
    this.route.params.subscribe(params => {
      this.templateId = params['templateId'];
    });
  }

  ngOnInit(): void {
    this.eventService.dispatchEvent('disableChat', {});
    if (!this.patientId) {
      // Handle error: Redirect to login or show a message
    }
  }

  ngOnDestroy(): void {
    this.eventService.dispatchEvent('enableChat', {});
  }
}
